export const toUserInputInfo = (state = {}, action) => {
    switch (action.type) {
        case "TO_USERINPUT_INFO": {
            return {
                hotelId: action.payload.toUserInputInfo.hotelId,
                hotelName: action.payload.toUserInputInfo.hotelName,
                planId: action.payload.toUserInputInfo.planId,
                planName: action.payload.toUserInputInfo.planName,
                planFee: action.payload.toUserInputInfo.planFee,
                roomNum: action.payload.toUserInputInfo.roomNum,
                roomType: action.payload.toUserInputInfo.roomType,
                startDate: action.payload.toUserInputInfo.startDate,
                endDate: action.payload.toUserInputInfo.endDate,
                reserveId: action.payload.toUserInputInfo.reserveId,
                cancelDescriptions: action.payload.toUserInputInfo.cancelDescriptions,
                searchReserveId: action.payload.toUserInputInfo.searchReserveId,
                completeFlg: action.payload.toUserInputInfo.completeFlg
            };
        }
        default: {
            return state;
        }
    }
};
